module.exports = __webpack_public_path__ + "static/media/arts_9.5b1b381f.jpg";